import { css } from '@emotion/css';

export const selectCx = css`
  &.MuiInputBase-root:before {
    border-color: #e0e0e0;
  }

  div.MuiInputBase-input {
    color: #5e5e5e;
    font-weight: 600;
  }

  /* &.MuiInputBase-root {
    margin-top: 0;

    &::before,
    &::after {
      display: none;
    }

    border: 1px solid #e0e0e0;
    border-radius: 0.5rem;
    .MuiSelect-select {
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
      padding-left: 0.75rem;
      &:focus {
        background-color: transparent;
      }
    }

    &.Mui-focused {
      .MuiSelect-root {
        border-color: #66cdf6;
      }
    }

    &.Mui-disabled {
      cursor: not-allowed;
      color: #757575;
      background-color: #ededed;
      border-color: #c2c2c2;
      .MuiSelect-select {
        cursor: inherit;
        color: inherit;
      }
      input {
        cursor: inherit;
        color: inherit;
      }
    }

    &.Mui-error {
      border-color: #db4d3d;
    }

    .MuiOutlinedInput-notchedOutline {
      display: none;
    }

    input {
      top: 0;
      opacity: 1;
      border: 0;
      background-color: transparent;
      padding-left: 0.75rem;
      font-size: 0.875rem;
      color: #757575;
    }

    &[data-filled='true'] {
      input {
        opacity: 0;
      }
    }
  } */
`;
